/** Icons for module sub-items (replaces generic dots). */
export const getSubItemIconClass = (subItem) => {
  const key = (subItem?.menu_key || '').toLowerCase();
  const title = (subItem?.title || '').trim().toLowerCase();

  // Projects children share menu_key `project` for access — differentiate by title.
  if (key === 'project') {
    if (title === 'dashboard') return 'fas fa-th-large';
    if (title === 'project list') return 'fas fa-list-ul';
    if (title === 'project tasks') return 'fas fa-clipboard-list';
    if (title === 'create new project') return 'fas fa-plus-circle';
    return 'fas fa-briefcase';
  }

  // Forum children share menu_key `forum_list` for Dashboard + Forums.
  if (key === 'forum_list') {
    if (title === 'dashboard') return 'fas fa-th-large';
    return 'fas fa-comments';
  }

  const byKey = {
    task_list: 'fas fa-clipboard-list',
    worksheet: 'fas fa-table',
    work_register: 'fas fa-book',
    work_register_team: 'fas fa-users',
    forum_create: 'fas fa-comment-medical',
    invoice_scanner_access: 'fas fa-file-invoice-dollar',
    doc_dashboard: 'fas fa-tachometer-alt',
    doc_my_documents: 'fas fa-folder-open',
    doc_shared: 'fas fa-share-alt',
    doc_favorites: 'fas fa-star',
    doc_classifications: 'fas fa-tags',
    credential_vault_list: 'fas fa-key',
    credential_vault_settings: 'fas fa-shield-alt',
    settings_users: 'fas fa-user-friends',
    flowdo_roles: 'fas fa-user-tag',
    settings_staff: 'fas fa-id-badge',
    settings_user_settings: 'fas fa-user-cog',
    settings_access_control: 'fas fa-user-lock',
    settings_branches: 'fas fa-code-branch',
    settings_departments: 'fas fa-sitemap',
    settings_sub_departments: 'fas fa-project-diagram',
    settings_designations: 'fas fa-award',
    settings_vehicle: 'fas fa-car',
  };

  if (title === 'performance report') return 'fas fa-chart-line';
  if (title.includes('personal credential')) return 'fas fa-user-lock';
  if (title.includes('corporate credential')) return 'fas fa-building';
  if (title === 'credentials vault') return 'fas fa-shield-alt';

  if (byKey[key]) return byKey[key];

  return 'fas fa-angle-right';
};

/** Icons for Settings sidebar / flyout items. */
export const getSettingsItemIconClass = (item) => {
  const id = (item?.id || '').toLowerCase();
  const key = (item?.menu_key || '').toLowerCase();
  const label = (item?.label || '').trim().toLowerCase();

  const byId = {
    'edit-profile': 'fas fa-user-edit',
    'change-password': 'fas fa-key',
    'add-user': 'fas fa-user-plus',
    'add-role': 'fas fa-user-shield',
    'manage-users': 'fas fa-users',
    'flowdo-roles': 'fas fa-user-tag',
    'access-control': 'fas fa-user-lock',
    branches: 'fas fa-code-branch',
    departments: 'fas fa-sitemap',
    'sub-departments': 'fas fa-project-diagram',
    'vault-passwords': 'fas fa-shield-alt',
    staff: 'fas fa-id-badge',
    vehicle: 'fas fa-car',
    designations: 'fas fa-award',
    subscriptions: 'fas fa-file-invoice-dollar',
    'credit-wallet': 'fas fa-wallet',
    'snap-bill-config': 'fas fa-cog',
  };

  if (byId[id]) return byId[id];

  if (key) {
    const fromMenu = getSubItemIconClass({ menu_key: key, title: label });
    if (fromMenu !== 'fas fa-angle-right') return fromMenu;
  }

  return 'fas fa-angle-right';
};
